import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PackageCounterPageRoutingModule } from './package-counter-routing.module';

import { PackageCounterPage } from './package-counter.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    PackageCounterPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [PackageCounterPage]
})
export class PackageCounterPageModule {}
